import React from 'react'

const Checkbox = ({ color, size = 28 }: { color: string; size?: any }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='14' cy='14' r='14' fill={color} />
      <path
        d='M18.8 10.3999L11.6404 17.5999L9.19995 15.1456'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Checkbox
